<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Monthly Attendance Report</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
                        @click="putnull" persistent-hint hint="Please Select Academic Year " />
                </v-col>

                <v-col sm="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv"
                        @click="putnull" persistent-hint hint="Please Select Standard " />
                </v-col>
                <v-col sm="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
                        item-text="div_name" label="Division" outlined @click="putnull" persistent-hint
                        hint="Please Select Division" />
                </v-col>
                <v-col cols="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="year" :items="year_list"
                        item-text="name" item-value="name" label="Select Year" outlined persistent-hint
                        hint="Please Select Year" />
                </v-col>
                <v-col cols="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="month" :items="month_list"
                        item-text="name" return-object label="Select Month" outlined persistent-hint
                        hint="Please Select Month" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="stud_status" :items="status_list"
                        item-text="name" return-object label="Status" outlined persistent-hint hint="Select Status" />
                </v-col>
                <v-col sm="2" v-if="sel_ay_data && sel_std_data && div && month && year">
                    <v-btn class="mt-6 button" @click="getMonthlyAttendanceData()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="month_attendance != ''">
            <v-row>
                    <v-btn rounded color="success" outlined class="ml-2"
                        @click="fnExcelReport('my-table-id', 'MonthlyAttendendanceReport')" :loading="loader"><v-icon
                            color="success">mdi-export</v-icon>Export</v-btn>
                    <v-btn rounded color="primary" outlined @click="printPDF" class="ml-2">
                        <v-icon color="primary">mdi-file-pdf</v-icon> PDF
                    </v-btn>
            </v-row>
            
            <div id="my-table-id">
                <div v-if="org_basic_data">
                    <v-row dense justify="center">
                        <div class="pdf-header ">
                            <img 
                                v-if="org_basic_data.school_logo"
                                :src="org_basic_data.school_logo"
                                class="pdf-logo print-only"
                            />
                            <div class="pdf-title">
                                <center>
                                    <h2><strong>{{ org_basic_data.trust_name }}</strong></h2>
                                    <h3><strong>{{ org_basic_data.school_name }}</strong></h3>
                                </center>
                            </div>
                        </div>
                    </v-row>
                </div>
                <div>
                    <center>
                        <strong>
                            ATTENDANCE FOR {{ sel_std_data.std }} {{ div.div_name }} THE MONTH OF {{ month.name }} {{
                            year }}
                            <br>
                            No. Of Working Days {{ total_working_days }}
                        </strong>
                    </center>
                </div>

                <div class="scroll">
                    <v-simple-table dense class="elevation-1 mytable" fixed-header height="500px">
                        <thead>
                            <tr>
                                <!-- <th class="">Sr. No.</th> -->
                                <th class="">Registration No.</th>
                                <th class="">Roll No.</th>
                                <th class="">Name</th>
                                <th class="" v-for="i, index4 in date_header" :key="index4">{{ i }}</th>
                                <th colspan="" class=""> Present Days</th>
                                <!-- <th class="">Date Of Birth</th>
                                <th class="">Age</th>
                                <th class="">Caste</th>
                                <th class="">Mother's Name</th> -->
                            </tr>
                        </thead>
                        <tbody style="overflow-y: scroll;">
                            <tr v-for="(s) in month_attendance" :key="s.id">
                                <!-- <td>{{ index1 + 1 }}</td> -->
                                <td>{{ s.reg_no }}</td>
                                <td>{{ s.roll_no }}</td>
                                <td>{{ s.name }}</td>
                                <td v-for="j, index in s.day_att" :key="index">{{ j }}</td>
                                <td>
                                    {{ s.present_cnt }}
                                </td>
                                
                                <!-- <td>{{ s.dob }}</td>
                                <td>{{ s.years }} Years {{ s.months }} Months</td>
                                <td>{{ s.caste }}</td>
                                <td>{{ s.mothers_name }}</td> -->
                            </tr>
                            <tr></tr>
                            <tr>
                                <td colspan="3">
                                    <strong>No. of Girls Present</strong> <br />
                                </td>
                                <td v-for="j, index in present_cnt_girls" :key="index">{{ j }}</td>
                                <td>{{ total_present_girls }} </td>
                                 <!--<td></td>
                                <td></td>
                                <td></td>
                                <td></td> -->
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <strong>No. of Boys Present</strong> <br />
                                </td>
                                <td v-for="j, index in present_cnt_boys" :key="index">{{ j }}</td>
                                <td>{{ total_present_boys }}</td>
                                 <!--<td></td>
                                <td></td>
                                <td></td>
                                <td></td> -->
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <strong>Total Present</strong> <br />
                                </td>
                                <td v-for="j, index in present_cnt" :key="index">{{ j }}</td>
                                <td>{{ total_present_days }}</td>
                                 <!--<td></td>
                                <td></td>
                                <td></td>
                                <td></td> -->
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <strong>No. of Girls Absent </strong> <br />
                                </td>
                                <td v-for="j, index in absent_cnt_girls" :key="index">{{ j }}</td>
                                <td>{{ total_absent_girls }}</td>
                                 <!--<td></td>
                                <td></td>
                                <td></td>
                                <td></td> -->
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <strong>No. of Boys Absent </strong> <br />
                                </td>
                                <td v-for="j, index in absent_cnt_boys" :key="index">{{ j }}</td>
                                <td>{{ total_absent_boys }}</td>
                                <!-- <td></td>
                                <td></td>
                                <td></td>
                                <td></td> -->
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <strong>Total Absent </strong> <br />
                                </td>
                                <td v-for="j, index in absent_cnt" :key="index">{{ j }}</td>
                                 <td>{{ total_absents }}</td>
                                <!--<td></td>
                                <td></td>
                                <td></td>
                                <td></td> -->
                            </tr>
                            <tr>
                                <td colspan="3">
                                    <strong>Total Girls : </strong> {{ total_girls }} 
                                    <br />
                                    <strong>Total Boys : </strong> {{ total_boys }}<br />
                                    <strong>Total Students : </strong> {{ total_stud_count }} 
                                </td>
                                <td v-for="j, index in present_cnt" :key="index"></td>
                                <td></td>
                                 <!--<td></td>
                                <td></td>
                                <td></td>
                                <td></td> -->
                            </tr>
                            <!-- <tr>
                                <td colspan="3">
                                  
                                </td>
                                <td v-for="j, index in date_size" :key="index"></td>
                                 <td></td><br>
                             
                            </tr> -->
                            <tr>
                                <td :colspan="3 + date_size">
                                    <v-row dense justify="center" v-for="index, i in total_holidays" :key="index">
                                        <strong>{{ i + 1 }}.</strong> {{ index }}
                                    </v-row>
                                        <v-simple-table dense class="elevation-1 mytable" fixed-header >  
                                            <tr>
                                                <td><strong>1) Total Present Days <br>
                                        Boys : {{ total_present_boys }} <br>
                                        Girls : {{ total_present_girls }} <br>
                                        Class : {{ total_present_days }}
                                    </strong> 
                                                </td>
                                                <td> <strong>2) Presenty Percentage
                                        <br>
                                        <!-- = Total Present Days * 100 / Strength * Working Days -->
                                        Boys : {{ presenty_percentage_boys }} <br>
                                        Girls : {{ presenty_percentage_girls }} <br>
                                        Class : {{ presenty_percentage_class }}
                                    </strong> </td>    
                                                <td><strong>3) Average Attendance <br>   
                                                    <!-- = Total Present Days / Working Days  -->
                                        Boys : {{ avg_att_boys }} <br>
                                        Girls : {{ avg_att_girls }} <br>
                                        Class : {{ avg_att_class }}
                                    </strong> </td>       
                                            </tr>          
                                        </v-simple-table> 
                                   
                                </td>
                                <td>
                                    <br />
                                    <br />
                                    <br />
                                    <hr />
                                    <br />
                                    <!-- <strong>Class Teacher</strong> -->
                                </td>
                               
                               
                                    <!-- <strong>Total No. Of Working Days - {{ total_working_days }} </strong> -->
                               
                                    <!-- <strong>Daily Average Attendance</strong> -->
                               
                                <!-- <td></td> -->
                            </tr>
                            <tr>
                                <td :colspan="3 + date_size">
                                    <v-simple-table class="elevation-1 mytable"> 
                                    <tr style="border: none;">
                                        <td style="border: none;">Teacher</td> 
                                       <td style="border: none;"> Clerk</td> 
                                       <td style="border: none;">Principal</td> 
                                    </tr>
                            </v-simple-table>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                      
                </div>
            </div>
        </v-card>
    </div>
    <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
export default {
    data: () => ({
        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        title: "",
        description: "",
        headers: [
            { text: "Sr No", value: "srno" },
            // { text: "Date", value: "date" },
            { text: "Learner", value: "learner" },
            { text: "Standard", value: "standard" },
            { text: "Division", value: "division" },
            { text: "Roll No", value: "roll_no" },
            { text: "Total", value: "total" },
            { text: "Present", value: "total_present" },
            { text: "Absent", value: "total_absent" },
            { text: "Percentage", value: "percentage" },
        ],
        table_fields: {
            "Sr No ": "srno",
            Learner: "learner",
            Standard: "standard",
            Division: "division",
            Total: "total",
            Present: "total_present",
            Absent: "total_absent",
            Percentage: "percentage",
        },
        total_stud_count: null,
        ay_std_div_list: null,
        sel_ay_data: null,
        show_tt: false,
        std_div_list: null,
        sel_std_data: null,
        div_list: null,
        div: null,
        overlay: false,
        fetch_loader: false,
        month_attendance: [],
        picker: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        date: new Date().toISOString().substr(0, 7),
        //date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        learner_attendance_info: [],
        date_header: [],
        month: null,
        year: "",
        year_list: [],
        month_list: [
            { name: "January", id: "1", month_number: "1" },
            { name: "February", id: "2", month_number: "2" },
            { name: "March", id: "3", month_number: "3" },
            { name: "April", id: "4", month_number: "4" },
            { name: "May", id: "5", month_number: "5" },
            { name: "June ", id: "6", month_number: "6" },
            { name: "July", id: "7", month_number: "7" },
            { name: "August", id: "8", month_number: "8" },
            { name: "September", id: "9", month_number: "9" },
            { name: "October", id: "10", month_number: "10" },
            { name: "November", id: "11", month_number: "11" },
            { name: "December", id: "12", month_number: "12" },
        ],
        total_girls: null,
        total_boys: null,
        total_present: null,
        total_previous: null,
        total_overall: null,
        date_size: null,
        present_cnt: null,
        present_cnt_girls: null,
        present_cnt_boys: null,
        absent_cnt: null,
        absent_cnt_girls: null,
        absent_cnt_boys: null,
        org_basic_data: [],
        total_working_days: null,
        total_holidays: null,
        role: null,
        status_list: [],
        stud_status: null,
        total_present_days: null,
        total_present_boys: null,
        total_present_girls: null,
        presenty_percentage_boys: null,
        presenty_percentage_girls: null,
        avg_att_girls: null,
        avg_att_boys: null,
        avg_att_class: null,
        presenty_percentage_class: null,
        total_absents: null,
        total_absent_girls: null,
        total_absent_boys: null,
    }),
    methods: {
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            // var blob = new Blob([tab_text], {
            //     type: "application/vnd.ms-excel;charset=utf-8",
            // });
            // window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const filename = name + ".xls";

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        getMonthlyAttendanceData() {
            const data = {
                month: this.date,
                ay: this.sel_ay_data.ay_id,
                standard: this.sel_std_data.std_id,
                division_offering: this.div,
                months: this.month.id,
                year: this.year,
                stud_status: this.stud_status.id,
            };
            this.overlay = true;
            axios
                .post("/Academics/getWWSMonthlyAttendanceData", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.month_attendance = res.data.month_attendance;
                        this.date_header = res.data.date_header;
                        this.total_girls = res.data.total_girls;
                        this.total_present_days = res.data.total_present_days;
                        this.total_present_boys = res.data.total_present_boys;
                        this.total_present_girls = res.data.total_present_girls;
                        this.avg_att_girls = res.data.avg_att_girls;
                        this.avg_att_boys = res.data.avg_att_boys;
                        this.avg_att_class = res.data.avg_att_class;
                        this.presenty_percentage_class = res.data.presenty_percentage_class
                        this.total_boys = res.data.total_boys;
                        this.total_present = res.data.total_present;
                        this.total_stud_count = res.data.total_stud_count
                        this.total_previous = res.data.total_previous;
                        this.total_overall = res.data.total_overall;
                        this.date_size = res.data.date_size;
                        this.present_cnt = res.data.present_cnt
                        this.present_cnt_boys = res.data.present_cnt_boys
                        this.present_cnt_girls = res.data.present_cnt_girls
                        this.absent_cnt = res.data.absent_cnt
                        this.absent_cnt_girls = res.data.absent_cnt_girls
                        this.absent_cnt_boys = res.data.absent_cnt_boys
                        this.org_basic_data = res.data.org_basic_data;
                        this.total_working_days = res.data.total_working_days;
                        this.presenty_percentage_girls = res.data.presenty_percentage_girls
                        this.presenty_percentage_boys = res.data.presenty_percentage_boys
                        this.total_holidays = res.data.total_holidays;
                        this.total_absent_boys = res.data.total_absent_boys;
                         this.total_absent_girls = res.data.total_absent_girls;
                         this.total_absents = res.data.total_absents;
                        this.overlay = false;
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("red", res.data.fmsg);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.overlay = false;
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    // this.selected_date=""
                });
        },
        getStd() {
            this.std_div_list = null;
            this.sel_std_data = null;
            this.div_list = null;
            this.div = null;
            this.std_div_list = this.sel_ay_data.std_list;
        },
        getDiv() {
            this.div_list = this.sel_std_data.div_list;
            this.div = this.div_list[0];
            if (this.div_list.length == 0) {
                alert("No division found!!!");
                this.div_list = null;
            }
        },
        putnull() {
            this.learner = [];
        },
        onLoad() {
            this.role = localStorage.getItem("para_role");
            const data = {
                role: this.role,
            };
            axios
                .post("/commonAPI/get_ay_std_div_wws_by_access", data)
                .then((res) => {
                    this.ay_std_div_list = res.data.data;
                    this.sel_ay_data = res.data.curr_ay;
                    this.status_list = res.data.status_list;
                    this.stud_status = this.status_list[0];
                    //this.month_list=res.data.month_list
                    this.year_list=res.data.year_list
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => { });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please Select Proper Data.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
       

        // printPDF() {
        //     const doc = new jsPDF("l", "mm", "a4");
        //     const img = new Image();
        //     doc.setFontSize(14);
        //     const pageWidth = doc.internal.pageSize.getWidth()
        //     doc.setFontSize(11)
        //     doc.text(`${this.org_basic_data.trust_name || ""}`, pageWidth / 2, 6, { align: "center" });
        //     doc.text(`${this.org_basic_data.school_name || ""}`, pageWidth / 2, 10, { align: "center" });
        //     doc.setFontSize(11)
        //     doc.text(`ATTENDANCE FOR ${this.sel_std_data.std} ${this.div.div_name} THE MONTH OF ${this.month.name} ${this.year}`,pageWidth / 2,16,{ align: "center" })
        //     doc.setFontSize(11)
        //     doc.text(` No. Of Working Days ${this.total_working_days }`,pageWidth / 2,20,{ align: "center" })

        //     let startY = 22;

        //     const wrappers = document.querySelectorAll("#my-table-id .v-data-table__wrapper");

        //     const topLevelWrappers = Array.from(wrappers).filter(wrapper => {
        //         return !wrapper.parentElement.closest(".v-data-table__wrapper");
        //     });

        //     topLevelWrappers.forEach((wrapper) => {
        //         const table = wrapper.querySelector("table");
        //         if (!table) return;

        //         const clonedTable = table.cloneNode(true);
                
        //         clonedTable.querySelectorAll("tr").forEach(row => {
        //             if (row.querySelector("table")) {
        //                 row.remove();
        //             }
        //         });

        //         autoTable(doc, {
        //             html: clonedTable,
        //             startY: startY,
        //             styles: {
        //                 fontSize: 6,
        //                 cellPadding: 1,
        //                 overflow: "linebreak",
        //             },
        //             theme: "grid",
        //             margin: { left: 5, right: 5 },
        //         });

        //         startY = doc.lastAutoTable.finalY + 5;
        //     });

        //     autoTable(doc, {
        //         startY: startY,
        //         theme: "grid",
        //         margin: { left: 5, right: 5 },
        //         styles: { fontSize: 7, cellPadding: 2 },
        //         head: [["1) Total Present Days", "2) Presenty Percentage", "3) Average Attendance"]],
        //         body: [
        //             [
        //                 `Boys : ${this.total_present_boys}\nGirls : ${this.total_present_girls}\nClass : ${this.total_present_days}`,
        //                 `Boys : ${this.presenty_percentage_boys}\nGirls : ${this.presenty_percentage_girls}\nClass : ${this.presenty_percentage_class}`,
        //                 `Boys : ${this.avg_att_boys}\nGirls : ${this.avg_att_girls}\nClass : ${this.avg_att_class}`,
        //             ],
        //         ],
        //     });

        //     startY = doc.lastAutoTable.finalY + 10;

        //     autoTable(doc, {
        //         startY: startY,
        //         theme: "grid",
        //         margin: { left: 5, right: 5 },
        //         styles: { fontSize: 7, cellPadding: 4 },
        //         body: [["Teacher", "Clerk", "Principal"]],
        //     });

        //     doc.save("Monthly_Attendance_Report.pdf");
        // }
        // printPDF() {
        //     if (!this.month_attendance || !this.month_attendance.length) {
        //         alert("No attendance data to print.");
        //         return;
        //     }

        //     const printContent = document.getElementById("my-table-id").innerHTML;
        //     const win = window.open('', '', 'width=1200,height=800');
        //     win.document.write(`
        //         <html>
        //         <head>
        //             <style>
        //                 @page { 
        //                     size: A4 landscape; 
        //                     margin: 10mm;
        //                     margin-top: 5mm;
        //                     margin-bottom: 5mm;
        //                 }
                    
        //                 @media print {
        //                     html, body {
        //                         -webkit-print-color-adjust: exact;
        //                         print-color-adjust: exact;
        //                     }
        //                 }
        //                 table { border-collapse: collapse; width: 100%; }
        //                 th, td { border: 1px solid #ccc; padding: 2px; font-size: 10px; text-align: center; }

        //                 body { 
        //                     font-family: Arial; 
        //                 }

        //                 .pdf-header {
        //                     position: relative;
        //                     width: 100%;
        //                     height: 80px; 
        //                 }

        //                 .pdf-logo {
        //                     position: absolute;
        //                     left: 0;
        //                     top: 0;
        //                     width: 70px;
        //                 }

        //                 .pdf-title {
        //                     text-align: center;
        //                 }

        //                 table { 
        //                     margin-top: 5px;
        //                     border-collapse: collapse; 
        //                     width: 100%; 
        //                 }

        //                 th, td { 
        //                     border: 1px solid #ccc; 
        //                     padding: 2px; 
        //                     font-size: 10px; 
        //                     text-align: center; 
        //                 }
        //             </style>
        //         </head>
        //         <body>
        //             ${printContent}
        //         </body>
        //         </html>
        //         `);

        //     win.document.close();

        //     win.focus();

        //     // wait for content to load
        //     setTimeout(() => {
        //         win.print();
        //         win.close();
        //     }, 500);
        // }
    //   printPDF() {
    //         if (!this.month_attendance || !this.month_attendance.length) {
    //             alert("No attendance data to print.");
    //             return;
    //         }
    //         const printContent = document.getElementById("my-table-id").innerHTML;
    //         const win = window.open('', '', 'width=1200,height=800');
    //         win.document.write(`
    //             <html>
    //             <head>
    //                 <style>
    //                     @page { 
    //                         size: A4 landscape; 
    //                         margin: 10mm;
    //                         margin-top: 5mm;
    //                         margin-bottom: 5mm;
    //                     }
    //                     @media print {
    //                         html, body {
    //                             -webkit-print-color-adjust: exact;
    //                             print-color-adjust: exact;
    //                         }
    //                     }
    //                     body { 
    //                         font-family: Arial; 
    //                     }

    //                     .pdf-header {
    //                         position: relative;
    //                         width: 100%;
    //                         height: 80px; 
    //                     }

    //                     .pdf-logo {
    //                         position: absolute;
    //                         left: 0;
    //                         top: 0;
    //                         width: 70px;
    //                     }

    //                     .pdf-title {
    //                         text-align: center;
    //                     }

    //                     table { 
    //                         margin-top: 5px;
    //                         border-collapse: collapse; 
    //                         width: 100%; 
    //                     }

    //                     th, td { 
    //                         border: 1px solid #ccc; 
    //                         padding: 2px; 
    //                         font-size: 10px; 
    //                         text-align: center; 
    //                     }
    //                 </style>
    //             </head>
    //             <body>
    //                 ${printContent}
    //             </body>
    //             </html>
    //             `);

    //         win.document.close();

    //         win.focus();

    //         // wait for content to load
    //         setTimeout(() => {
    //             win.print();
    //             win.close();
    //         }, 500);
    //     }
    printPDF() {
            if (!this.month_attendance || !this.month_attendance.length) {
                alert("No attendance data to print.");
                return;
            }
            const printContent = document.getElementById("my-table-id").innerHTML;
            const win = window.open('', '', 'width=1200,height=800');
            win.document.write(`
                <html>
                <head>
                    <style>
                        @page { 
                            size: A4 landscape; 
                            margin: 10mm;
                            margin-top: 5mm;
                            margin-bottom: 5mm;
                        }
                        @media print {
                            html, body {
                                -webkit-print-color-adjust: exact;
                                print-color-adjust: exact;
                            }
                        }
                        body { 
                            font-family: Arial; 
                        }

                        .pdf-header {
                            position: relative;
                            width: 100%;
                            height: 80px; 
                        }

                        .pdf-logo {
                            position: absolute;
                            left: 0;
                            top: 0;
                            width: 70px;
                        }

                        .pdf-title {
                            text-align: center;
                        }

                        table { 
                            margin-top: 5px;
                            border-collapse: collapse; 
                            width: 100%; 
                        }

                        th, td { 
                            border: 1px solid #ccc; 
                            padding: 2px; 
                            font-size: 10px; 
                            text-align: center; 
                        }
                    </style>
                </head>
                <body>
                    ${printContent}
                </body>
                </html>
                `);

            win.document.close();

            win.focus();

            // wait for content to load
            setTimeout(() => {
                win.print();
                win.close();
            }, 500);
        }
    },
    mounted() {
        this.onLoad();
    },
    watch: {},
};
</script>
<style scoped>
.table {
    border: none !important;
}

input[type="date"] {
    width: 30%;
    display: inline-block;
    padding: 0.3rem;
    border: 1px solid gray;
    border-radius: 30px;
    box-sizing: border-box;
    padding-top: none !important;
    margin-top: none !important;
}

.text-color {
    font-weight: bold;
    color: red;
}

.scroll {
    overflow-x: scroll;
}

.text-color {
    font-weight: bold;
    color: red;
    font-size: small;
}

tr,
td,
th {
    border: 1px solid #ccc;
    text-align: center;
    font-size: small;
}

tr,
tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
    font-size: small;
}

td {
    margin: 0.3rem !important;
    padding: 0.4rem !important;
    font-size: small;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

v-simple-table {
    white-space: nowrap !important;
    text-align: center;
    font-size: small;
}

body { 
    font-family: Arial; 
}

.pdf-header {
    position: relative;
    width: 100%;
}

.pdf-logo {
    position: absolute;
    left: 0;
    top: 0;
    width: 70px;
    margin-left: 20px;
    margin-top: 20px;
}

.pdf-title {
    text-align: center;
}

table { 
    border-collapse: collapse; 
    width: 100%; 
}

th, td { 
    border: 1px solid #ccc; 
    padding: 2px; 
    text-align: center; 
}

.print-only {
    display: none;
}

</style>
